import React, { useState } from 'react';
import './AskConsult.css';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import ConatctUsData from '../../assest/data/ContactUsData';

import AOS from 'aos'
import 'aos/dist/aos.css'
import { PageHead, SectionWrap } from '../../Components';
import Subscribe from '../Subscribe/Subscribe';
AOS.init();

export default function AskConsult() {
    const { t, i18n } = useTranslation();
    const form = useRef();
    // const apiUrl = 'http://localhost/server/testServer/send_consultation.php'; // مسار سكريبت PHP الجديد
    const apiUrl = 'https://www.albarede.com/server/send_consultation.php'; // استخدم هذا في بيئة الإنتاج

    const [statusMessage, setStatusMessage] = useState(''); // حالة لعرض رسالة النجاح/الفشل
    const [isSending, setIsSending] = useState(false); // حالة لتعطيل الزر أثناء الإرسال

    const sendEmail = async (e) => { // جعل الدالة async
        e.preventDefault();
        setStatusMessage('جارٍ إرسال طلب الاستشارة...'); // رسالة أثناء الإرسال
        setIsSending(true); // تعطيل الزر

        // جمع البيانات من النموذج يدوياً لأننا سنرسلها كـ JSON
        const formData = new FormData(form.current);
        const data = {
            user_name: formData.get('user_name'),
            user_number: formData.get('user_number'),
            user_email: formData.get('user_email'),
            subject: formData.get('subject'),
            message: formData.get('message'),
        };

        // التحقق من الحقول الأساسية قبل الإرسال
        if (!data.user_name.trim() || !data.user_email.trim() || !data.subject.trim() || !data.message.trim()) {
            setStatusMessage('الرجاء ملء جميع الحقول المطلوبة.');
            setIsSending(false);
            return;
        }

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (response.ok && result.success) {
                setStatusMessage('تم إرسال طلب الاستشارة بنجاح. سنقوم بالرد عليك قريباً.');
                form.current.reset(); // مسح النموذج بعد النجاح
            } else {
                setStatusMessage(`فشل الإرسال: ${result.message || 'خطأ غير معروف'}`);
            }
        } catch (error) {
            console.error('Error sending consultation:', error);
            setStatusMessage('حدث خطأ أثناء الاتصال بالخادم. يرجى المحاولة لاحقاً.');
        } finally {
            setIsSending(false); // إعادة تمكين الزر
            // يمكن إخفاء الرسالة بعد فترة
            setTimeout(() => {
                setStatusMessage('');
            }, 5000); // إخفاء الرسالة بعد 5 ثوانٍ
        }
    };

    return (
        <>
            <div className="askContainer" id="discount">
                <PageHead 
                    title={t('footerTitle')}
                    summary={t("AskConsultDisc")}
                    btn={t('latestArticles')}
                    hrefBtn='/articles'
                />
                <SectionWrap>
                    <div>
                        <div className='card-holder'>
                            <ConatctUsData/>
                        </div>
                        <div className='social-media-contact'>
                            <ul>
                                <li><a href='/'><i className='fab fa-linkedin fa-lg'></i></a></li>
                                <li><a href='/'><i className='fab fa-twitter fa-lg'></i></a></li>
                                <li><a href='https://www.instagram.com/albarede_law/'><i className='fab fa-instagram fa-lg'></i></a></li>
                                <li><a href='https://www.facebook.com/profile.php?id=61579797128484'><i className='fab fa-facebook-f fa-lg'></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className='send-email' data-aos='fade-up'>
                        <form className='askForm' ref={form} onSubmit={sendEmail}>
                            {/* رسالة الحالة تظهر هنا */}
                            {statusMessage && (
                                <p className={`status-message ${statusMessage.includes('نجاح') ? 'success' : 'error'}`}>
                                    {statusMessage}
                                </p>
                            )}

                            <div>
                                <input type='text' name='user_name' placeholder={t('formName')} required/>
                                <input type='text' name='user_number' placeholder={t('formMobile')} required/>
                            </div>
                            <div>
                                <input type='email' name='user_email' placeholder={t('formEmail')} required/>
                                {/* تأكد من أن هذا الحقل له اسم (name) ليتم جمعه بواسطة FormData */}
                                <input type='text' name='subject' placeholder={t('formSub')} required/> 
                            </div>
                            <textarea name='message' rows={3} cols={30} placeholder={t('formDisc')} required></textarea>
                            <button type='submit' className='btn-email' disabled={isSending}>
                                {isSending ? 'جارٍ الإرسال...' : t('formBtn')}
                            </button>
                        </form>
                    </div>
                </SectionWrap>
                <div style={{marginBottom: '70px'}}>
                    <Subscribe />
                </div>
            </div>
        </>
    )
}
